import axios from "axios";

export const getTemplateComponents = async (token) => {
    try {
        const res = await axios.get("dialer/message-templates/components/", {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        console.log(res, "====================GetTemplateComponentsResponse===================");
        return res;
    } catch (err) {
        if (axios.isAxiosError(err)) {
            throw err.response?.data?.message || err.message || "Failed to fetch template components";
        } else {
            throw err;
        }
    }
};

export const AddTemplate = async (token, payload) => {
    try {
        const res = await axios.post("dialer/message-templates/", payload, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        console.log(res, "====================AddTemplateResponse===================");
        return res;
    } catch (err) {
        if (axios.isAxiosError(err)) {
            console.error("AddTemplate Axios Error Data:", err.response?.data);
            // If the backend returns detailed validation errors, extract and format them
            const serverMsg = err.response?.data?.message || err.response?.data?.detail;
            const validationErrors = err.response?.data?.data || err.response?.data?.errors || err.response?.data;
            let finalMsg = serverMsg || "Failed to add template";
            if (validationErrors && typeof validationErrors === 'object') {
                const details = Object.entries(validationErrors)
                    .map(([key, val]) => `${key}: ${Array.isArray(val) ? val.join(', ') : JSON.stringify(val)}`)
                    .join(' | ');
                if (details) {
                    finalMsg += ` (${details})`;
                }
            }
            throw finalMsg;
        } else {
            throw err;
        }
    }
};

export const EditTemplate = async (id, token, payload) => {
    try {
        const res = await axios.patch(`dialer/message-templates/?id=${id}`, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        console.log(res, "====================EditTemplateResponse===================");
        return res;
    } catch (err) {
        if (axios.isAxiosError(err)) {
            console.error("EditTemplate Axios Error Data:", err.response?.data);
            const serverMsg = err.response?.data?.message || err.response?.data?.detail;
            const validationErrors = err.response?.data?.data || err.response?.data?.errors || err.response?.data;
            let finalMsg = serverMsg || "Failed to edit template";
            if (validationErrors && typeof validationErrors === 'object') {
                const details = Object.entries(validationErrors)
                    .map(([key, val]) => `${key}: ${Array.isArray(val) ? val.join(', ') : JSON.stringify(val)}`)
                    .join(' | ');
                if (details) {
                    finalMsg += ` (${details})`;
                }
            }
            throw finalMsg;
        } else {
            throw err;
        }
    }
};

export const deleteTemplate = async (id, token) => {
    try {
        const res = await axios.delete(`dialer/message-templates/?id=${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return res;
    } catch (err) {
        if (axios.isAxiosError(err)) {
            throw err.response?.data?.message || err.message || "Failed to delete template";
        } else {
            throw err;
        }
    }
};
